(function () {
  if (window.__FormSpamDefenseInitialized) return;
  window.__FormSpamDefenseInitialized = true;

  const initFormSpamDefense = () => {
    const traps = document.querySelectorAll('[data-form-spam-defense]');
    if (!traps.length) return;

    const stateByForm = new WeakMap();
    const now = () => Date.now();
    const storagePrefix = 'diamondpans:form-spam:';

    const getForm = (target) => {
      if (!target) return null;
      if (target.tagName === 'FORM') return target;
      return target.closest?.('form') || null;
    };

    const getTrap = (form) => form?.querySelector?.('[data-form-spam-defense]') || null;

    const getConfig = (trap) => ({
      type: trap.dataset.formSpamType || 'public',
      honeypotName: trap.dataset.formSpamHoneypot || 'company_url',
      minMs: Number(trap.dataset.formSpamMinMs) || 1800,
      rateLimit: Number(trap.dataset.formSpamRateLimit) || 3,
      rateWindowMs: Number(trap.dataset.formSpamRateWindowMs) || 600000,
      messageField: trap.dataset.formSpamMessageField || '',
      minMessageChars: Number(trap.dataset.formSpamMinMessageChars) || 0,
      maxUrls: Number(trap.dataset.formSpamMaxUrls) || 0,
    });

    const getState = (form) => {
      let state = stateByForm.get(form);
      if (!state) {
        state = { startedAt: now(), interacted: false };
        stateByForm.set(form, state);
      }
      return state;
    };

    const resetForm = (form) => {
      if (!form || !getTrap(form)) return;
      stateByForm.set(form, { startedAt: now(), interacted: false });
    };

    const setMessage = (trap, message) => {
      const messageEl = trap.querySelector('[data-form-spam-message]');
      if (!messageEl) return;

      messageEl.hidden = !message;
      messageEl.textContent = message || '';
    };

    const getFieldByName = (form, name) =>
      Array.from(form.elements || []).find((field) => field.name === name) || null;

    const normalizeMessage = (value) =>
      String(value || '')
        .replace(/[ \t]{2,}/g, ' ')
        .replace(/[ \t]+\n/g, '\n')
        .replace(/\n{3,}/g, '\n\n')
        .trim();

    const countUrls = (value) => (String(value || '').match(/\b(?:https?:\/\/|www\.)\S+/gi) || []).length;

    const getStoredAttempts = (key, windowMs) => {
      try {
        const cutoff = now() - windowMs;
        return (JSON.parse(localStorage.getItem(key) || '[]') || []).filter((ts) => Number(ts) > cutoff);
      } catch (e) {
        return null;
      }
    };

    const recordAttempt = (key, attempts) => {
      try {
        localStorage.setItem(key, JSON.stringify([...attempts, now()]));
      } catch (e) {}
    };

    traps.forEach((trap) => {
      const form = trap.closest('form');
      if (form) getState(form);
    });

    ['input', 'focusin', 'keydown', 'pointerdown', 'touchstart'].forEach((eventName) => {
      document.addEventListener(
        eventName,
        (event) => {
          const form = getForm(event.target);
          if (!form || !getTrap(form)) return;

          getState(form).interacted = true;
        },
        true
      );
    });

    document.addEventListener(
      'submit',
      (event) => {
        const form = event.target;
        const trap = getTrap(form);
        if (!trap) return;

        const config = getConfig(trap);
        const state = getState(form);
        const honeypot = getFieldByName(form, config.honeypotName);

        if ((honeypot?.value || '').trim()) {
          event.preventDefault();
          return;
        }

        if (now() - state.startedAt < config.minMs) {
          event.preventDefault();
          setMessage(trap, 'Please wait a moment and try again.');
          return;
        }

        if (!state.interacted) {
          event.preventDefault();
          setMessage(trap, 'Please fill out the form before submitting.');
          return;
        }

        if (config.messageField) {
          const messageField = getFieldByName(form, config.messageField);
          const cleaned = normalizeMessage(messageField?.value || '');

          if (messageField) messageField.value = cleaned;

          if (config.minMessageChars && cleaned.length < config.minMessageChars) {
            event.preventDefault();
            setMessage(trap, 'Please add a little more detail and try again.');
            return;
          }

          if (config.maxUrls && countUrls(cleaned) > config.maxUrls) {
            event.preventDefault();
            setMessage(trap, 'Please remove extra links and try again.');
            return;
          }
        }

        const storageKey = `${storagePrefix}${config.type}`;
        const attempts = getStoredAttempts(storageKey, config.rateWindowMs);
        if (attempts && attempts.length >= config.rateLimit) {
          event.preventDefault();
          setMessage(trap, 'Please wait a few minutes before sending another submission.');
          return;
        }

        if (attempts) recordAttempt(storageKey, attempts);
        setMessage(trap, '');
      },
      true
    );

    window.__FormSpamDefenseReset = resetForm;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFormSpamDefense, { once: true });
  } else {
    initFormSpamDefense();
  }
})();
